module.exports = __webpack_public_path__ + "static/media/8.6a0e9177.png";